module.exports = __webpack_public_path__ + "static/media/postcard7thumb.05fbf9e2.jpg";